import moment from "@/utils/moment";

const deadPeopleDay = {
  name: "Finados",
  day: "11-02",
  activePurchase: true
};

const idependencyDay = {
  name: "Dia da Independência",
  day: "09-07",
  activePurchase: false
};

const christmasEve = {
  name: "Véspera de Natal",
  day: "12-24",
  activePurchase: true,
  max_starts_at: 15
};

const christmasEve23 = {
  name: "Véspera de Natal",
  day: "12-23",
  activePurchase: true
};

const tiradentes = {
  name: "Tiradentes",
  day: "04-21",
  activePurchase: true
};

const workDay = {
  name: "Dia do Trabalho",
  day: "05-01",
  activePurchase: true
};

const christmas = {
  name: "Natal",
  day: "12-25",
  activePurchase: false
};

const newYearEve = {
  name: "Véspera de Ano Novo",
  day: "12-31",
  activePurchase: true
};

const newYear = {
  name: "Ano Novo",
  day: "01-01",
  activePurchase: false
};

const carnavalEve = {
  name: "Véspera de Carnaval",
  day: "02-24",
  activePurchase: true
};

const carnaval = {
  name: "Carnaval",
  day: "02-25",
  activePurchase: true
};

const holidays = [
  idependencyDay,
  christmasEve,
  christmas,
  newYearEve,
  newYear,
  carnavalEve,
  carnaval,
  tiradentes,
  workDay,
  deadPeopleDay,
  christmasEve23
];

const dayFormat = "MM-DD";

const formatDay = day => moment(day).format(dayFormat);
const findHoliday = day => {
  day = formatDay(day);
  return holidays.find(el => el.day === day);
};
const daysWithDisabledPurchase = () =>
  holidays.filter(el => !el.activePurchase).map(el => el.day);

export default {
  daysWithDisabledPurchase,
  findHoliday,
  holidays,
  dayFormat
};



// WEBPACK FOOTER //
// ./src/utils/helpers/holiday.js